import { render } from "./NavDrawer.vue?vue&type=template&id=67b89f3f&scoped=true&ts=true"
import script from "./NavDrawer.vue?vue&type=script&lang=ts"
export * from "./NavDrawer.vue?vue&type=script&lang=ts"

import "./NavDrawer.vue?vue&type=style&index=0&id=67b89f3f&scoped=true&lang=css"

import exportComponent from "../../../../../../../build_modules/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b89f3f"]])

export default __exports__